import React, { useEffect, useState } from "react";
import apiMaestras from "../../../../../api/Maestras/api-maestras";
import { Convocatoria } from "../../../../../models/ConvocatoriasModel/convocatoria.model";
import "./Banner.scss";
import moment from "moment";
import { ReactComponent as CalendarIcon } from "../../../../../assets/calendar-detail.svg";
import ImageNotFound from "../../../../../assets/enmascarar-detail.png";
import apiDocumentos from "../../../../../api/Documentos/api-documentos";

interface IProps {
  convocatorias: Convocatoria;
}

export const BannerTwo: React.FC<IProps> = (props: IProps) => {
  const [dataImg, setDataImg] = useState<any>();
  const [LineasConvocatorias, setLineasConvocatorias] = useState([]);
  const [calculateDayStart, setCalculateDayStart] = useState<any>();
  const [calculateDayEnd, setCalculateDayEnd] = useState<any>();

  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }

  const getFilterLineaConvocatoria = (idLineaConvocatoria: number) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) return valueFilter[0].nombre;
  }

  const getImageConvocatoria = async () => {
    if (props.convocatorias?.portada_url) {
      const data = await apiDocumentos.consultarArchivo(props.convocatorias?.portada_url);
      if (data && data.data) {
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
          const base64String = reader.result;
          setDataImg(base64String);
        }
      }
    }
  }

  const calculateDate = (fechas: any) => {
    if (fechas !== null && fechas.length > 0) {
      const filterDateStart = fechas.filter((data) => data.clave === "Apertura");
      const filterDateEnd = fechas.filter((data) => data.clave === "Cierre");

      if (filterDateStart.length > 0) {
        setCalculateDayStart(moment(filterDateStart[0].valormin));
      }

      if (filterDateEnd.length > 0) {
        if (filterDateEnd[0].valormax && moment(filterDateEnd[0].valormax).isValid()) {
          setCalculateDayEnd(moment(filterDateEnd[0].valormax));
        } else {
          setCalculateDayEnd(moment(filterDateEnd[0].valormin));
        }
      }
    }
  }

  const getStatusConvocatoria = (convocatorias: any) => {
    let fechaactual = moment()
    if (convocatorias.fechas && convocatorias.fechas.length > 0) {
      for (var y in convocatorias.fechas) {
        let fechavalida =
          moment(convocatorias.fechas[y].valormax).isValid() ?
            moment(convocatorias.fechas[y].valormax) :
            moment(convocatorias.fechas[y].valormin);
        if (
          convocatorias.fechas[y].clave === "Apertura" &&
          moment(fechaactual).isBefore(moment(convocatorias.fechas[y].valormin))
        ) {
          convocatorias.estado = "En espera";
        }
        if (
          convocatorias.fechas[y].clave === "Apertura" &&
          moment(fechaactual).isSameOrAfter(moment(convocatorias.fechas[y].valormin))
        ) {
          convocatorias.estado = "Abierta";
        }
        if (
          convocatorias.fechas[y].clave === "Cierre" &&
          moment(fechaactual).isSameOrAfter(fechavalida)
        ) {
          convocatorias.estado = "Cerrada";
        }
        if (
          convocatorias.fechas[y].clave ===
          "Resolución de otorgamiento" &&
          moment(fechaactual).isSameOrAfter(fechavalida)
        ) {
          convocatorias.estado = "Cerrada";
        }
        if (!convocatorias.publico) {
          convocatorias.estado = "No publicada";
        }
      }
    }
  }

  useEffect(() => {
    getLineasConvocatorias();
  }, [])

  useEffect(() => {
    calculateDate(props.convocatorias.fechas);
    getStatusConvocatoria(props.convocatorias);
    getImageConvocatoria();
  }, [props.convocatorias]);

  getFilterLineaConvocatoria(props.convocatorias.linea_convocatoria)

  return (
    <div className="container-background-participantes-banner-two" style={{ backgroundImage: dataImg ? `url(${dataImg})` : `url(${ImageNotFound})`, height: '500px', backgroundSize: 'cover', backgroundAttachment: 'fixed',  boxShadow: 'inset 0 0 0 2000px rgba(11, 165, 198, 0.7)' }}>
      <div className="subcontainer-background-participantes">
        <div className="container-fluid2 container-date-banner-two">
          <div className="row-container-date-banner">
            <div
              style={{ lineHeight: "normal", paddingBottom: "10px" }}
              className="col-12 container-detalle-card-body-semibold-work font-size-22px font-color-FFFFFF"
            >
              Fechas de la convocatoria
            </div>

            <div className="row align-items-center" style={{ maxWidth: '600px' }}>
              <div className="col-12 col-md-2 font-family-Montserrat-Regular font-size-10px font-color-FFFFFF ">
                <p>
                  <CalendarIcon className="calendar-icon-banner-two" />
                </p>
              </div>

              {props.convocatorias.fechas ? (
                <>
                  <div
                    className="col-6 col-md-3 font-family-Montserrat-Regular font-size-10px font-color-FFFFFF"
                  >
                    <span className="no-margin container-detalle-card-body-bold" style={{ fontSize: '18px' }}>
                      <strong className="text-left container-detalle-card-body-bold">Inicia:</strong>
                    </span>{" "}
                    <div className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>
                      {
                        moment(calculateDayStart).format('DD MMM / YYYY')
                      }
                    </div>
                  </div>

                  <div className="col-6 col-md-7 font-family-Montserrat-Regular font-size-10px font-color-FFFFFF">
                    <span className="no-margin container-detalle-card-body-bold" style={{ fontSize: '18px' }}>
                      <strong className="container-detalle-card-body-bold">Finaliza:</strong>
                    </span>{" "}
                    <div className="container-detalle-card-body-regular" style={{ fontSize: '18px' }}>
                      {
                        moment(calculateDayEnd).format('DD MMM / YYYY')
                      }
                    </div>
                  </div>
                </>
              ) : <div
                className="col-6 font-family-Montserrat-Regular font-size-10px font-color-FFFFFF"
              >
                <span className="no-margin container-detalle-card-body-bold" style={{ fontSize: '18px' }}>
                  <strong className="text-left container-detalle-card-body-bold">No hay fechas seleccionadas para esta convocatoria</strong>
                </span>{" "}
              </div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
